(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4538],{

/***/ 53313:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universities/[country]/[university]",
      function () {
        return __webpack_require__(41568);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47046);
/* harmony import */ var _components_ErrorComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46412);
/* harmony import */ var _components_universityDetail_UniversityDetailComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12345);






const UniversityDetailPage = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { country , university  } = router.query;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#313145");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    // Ensure universityDetails is not undefined or empty
    if (!props.universityDetails || Object.keys(props.universityDetails).length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
    // Convert university details into an array if needed
    const universityArray = Array.isArray(props.universityDetails) ? props.universityDetails : Object.values(props.universityDetails || {});
    if (!universityArray || universityArray.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
    const filteredUniversityArray = universityArray.filter((uni)=>{
        const formattedCountrySlug = (country ?? "").toLowerCase().trim();
        const countryFromObject = uni.country?.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase().trim();
        return countryFromObject === formattedCountrySlug;
    });
    const universityData = filteredUniversityArray.find((uni)=>{
        const formattedPageSlug = (university ?? "").toLowerCase().trim();
        return uni?.slug?.toLowerCase().trim() === formattedPageSlug;
    });
    if (!universityData) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_3__/* .MetaTagsComp */ .r, {
                ...universityData?.meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_universityDetail_UniversityDetailComponent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                universityData: universityData,
                advertisements: props.advertisements,
                mobileAdvertisements: props.mobileAdvertisements,
                introAd: props.introAd
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (UniversityDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,4706,6751,9774,2888,179], function() { return __webpack_exec__(53313); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);